/** A deck screen's stated choices, normalised to the `{value, label}` shape the pickers take. Pure + React-free. */

import type { ScreenOption } from 'src/components/star-grid/api/reportEngineTypes';

export interface ChoiceOption {
  readonly value: string;
  readonly label: string;
}

const toChoice = (option: string | ScreenOption): ChoiceOption => {
  if (typeof option === 'string') return { value: option, label: option };
  const value = String(option.id ?? '');
  return { value, label: String(option.label ?? '').trim() || value };
};

/** The screen's choices in its own order, blank ids dropped and duplicates kept at their first position. */
export const screenChoices = (options: readonly (string | ScreenOption)[] | undefined): ChoiceOption[] => {
  const seen = new Set<string>();
  return (options ?? []).map(toChoice).filter((choice) => {
    if (!choice.value || seen.has(choice.value)) return false;
    seen.add(choice.value);
    return true;
  });
};
